// 用户相关
export const USER_IS_LOGIN = 'user/is_login';   // 是否已经登录
export const USER_SIGN_IN = 'user/sign_in';     // 登录
export const USER_SIGN_OUT = 'user/sign_out';   // 退出登录
export const USER_INFO = 'user/user_info';   // 用户信息

// 订单相关
export const ORDER_SHOP_ID = 'order/shop_id'; 
export const ORDER_STATUS = 'order/status'; 
